const styles = {
  paddingRow: {
    paddingTop: '7px',
    paddingBottom: '7px',
  },
};

export default styles;
